// extracted by mini-css-extract-plugin
export default {"wrapper":"editor_wrapper__QTFJs","editor":"editor_editor__xQXIX","editor_footer":"editor_editor_footer__76oEg","marked_wrap":"editor_marked_wrap__+VPyy"};